module.exports = __webpack_public_path__ + "img/tooltip.1bf973f7.svg";